/* The end state, centred on the desk. Canon: `zadania-c-runda5.html`'s `.reward` and `.tally`. */

.done {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.tally {
  display: flex;
  gap: var(--space-3);
  margin: var(--space-5) var(--space-0) var(--space-2);
}

.tallyCard {
  min-width: 130px;
  padding: var(--space-4) var(--space-5);
  text-align: left;
  background: var(--bg-card);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-xl);
}

.tallyFigure {
  display: block;
  font-size: var(--fs-home-figure);
  font-weight: var(--fw-extrabold);
  font-variant-numeric: tabular-nums;
  letter-spacing: var(--ls-home-figure);
  line-height: var(--lh-none);
  color: var(--text);
}

.tallyLabel {
  font-size: var(--fs-label);
  color: var(--text-2);
}

/* The ghost skin's B2C weight and ink, scoped under the reward so it outranks `shared/ui/ghostButton`
 * by specificity rather than by stylesheet order. */
.done .undo {
  display: inline-flex;
  gap: var(--space-6px);
  align-items: center;
  margin-top: var(--space-2);
  font-size: var(--type-control);
  font-weight: var(--fw-medium);
  color: var(--text);
}

.undoGlyph {
  width: 15px;
  height: 15px;
}
